import React from "react";
import { Route, Routes } from "react-router-dom";

import List from "./list";

export default function People() {
  return (
    <Routes>
      <Route path="/" element={<List />} />
    </Routes>
  );
}
